import React from "react";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { Container } from '@material-ui/core';
import Card from '@material-ui/core/Card';

export default class ComponentToPrint extends React.Component {

    render() {
        const tableData = this.props.data;
        const searchData = this.props.searchData;
        const total = this.props.total;
        const hrTotal = this.props.hrTotal;
        const dateArray = this.props.dateArray;

        return (
            <div className="p-2">
                <h3><center><u>Attendance Report Plucking & Sundry</u></center></h3>
                <div className="row pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Operation Entity: </b> {searchData.operationEntity}</div>
                    <div className="col"><b>Collection Point: </b> {searchData.collectionPoint}</div>
                    <div className="col"><b>Job Type: </b> {searchData.jobTypeID == 1 ? "Sundry" : "Plucking"}</div>
                    <div className="col"><b>Month: </b> {searchData.month}</div>

                </div>
                {tableData.length != 0 ?
                    <Container>
                        <Card style={{ justifycontent: 'center' }}>
                            <Paper style={{
                                table: {
                                    minWidth: 650,
                                },
                                dialog1: {
                                    width: 850,
                                }
                            }}>
                                <TableContainer>
                                    <Table aria-label="simple table">
                                        <TableHead>
                                            <TableRow style={{ border: "2px solid black" }}>
                                                <TableCell align="center" rowSpan={2} style={{ border: "2px solid black", fontWeight: "bold" }}>EMP No</TableCell>
                                                <TableCell align="center" rowSpan={2} style={{ border: "2px solid black", fontWeight: "bold" }}>Name (First Name)</TableCell>
                                                <TableCell align="center" colSpan={dateArray.length} style={{ border: "2px solid black", fontWeight: "bold" }}>Date</TableCell>
                                                <TableCell align="center" rowSpan={2} style={{ border: "2px solid black", fontWeight: "bold" }}>Total</TableCell>
                                            </TableRow>
                                            <TableRow style={{ border: "2px solid black" }}>
                                                {dateArray.map(x => {
                                                    return (
                                                        <TableCell key={x} align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>{x}</TableCell>
                                                    )
                                                })}
                                            </TableRow>
                                            <TableRow>
                                            </TableRow>
                                        </TableHead>
                                        {searchData.jobTypeID == 2 ?
                                            <TableBody>
                                                {tableData.map(item => {
                                                    let totalhr = 0;
                                                    return (
                                                        <TableRow style={{ border: "2px solid black" }} key={item.date}>
                                                            <>
                                                                <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>{item.registrationNumber}</TableCell>
                                                                <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold", }}>{item.firstName}</TableCell>
                                                            </>
                                                            {dateArray.map(x => {
                                                                const res = item.dataList.filter(y => parseInt(y.readTime.slice(8, 10)) == parseInt(x))
                                                                if (res.length > 0) {
                                                                    if (res[0].totalAmount >= res[0].configurationValue) {
                                                                        totalhr += 1;
                                                                    } else {
                                                                        totalhr += 0.5;
                                                                    }
                                                                } return (
                                                                    <>
                                                                        {res.length > 0 ?
                                                                            <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }} key={x.employeeID}>{res == undefined ? "-" :
                                                                                res[0].totalAmount >= res[0].configurationValue ? 1 : 0.5}</TableCell>
                                                                            :
                                                                            <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }} key={x.employeeID}>{"-"}</TableCell>
                                                                        }
                                                                    </>
                                                                )
                                                            })
                                                            }
                                                            <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>{parseFloat(totalhr)}</TableCell>
                                                        </TableRow >
                                                    )
                                                })}
                                                <TableRow style={{ border: "2px solid black" }}>
                                                    <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }} colSpan={2}>Total</TableCell>
                                                    {dateArray.map(x => {
                                                        const res = total.find(y => parseInt(y.readTime) === parseInt(x))
                                                        return (
                                                            <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>{res == undefined ? "-" : parseFloat(res.total).toFixed(1)}</TableCell>
                                                        )
                                                    })}
                                                    <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }} >{parseFloat(hrTotal).toFixed(1)}</TableCell>
                                                </TableRow>
                                            </TableBody> :
                                            <TableBody>
                                                {tableData.map(item => {
                                                    let totalhr = 0;
                                                    return (
                                                        <TableRow style={{ border: "2px solid black" }} key={item.date}>
                                                            <>
                                                                <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>{item.registrationNumber}</TableCell>
                                                                <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>{item.firstName}</TableCell>
                                                            </>
                                                            {
                                                                dateArray.map(x => {
                                                                    const res = item.dataList.filter(y => parseInt(y.readTime.slice(8, 10)) == parseInt(x))
                                                                    if (res.length > 0) {
                                                                        if (res[0].totalAmount > 50 && res[0].totalAmount <= 100) {
                                                                            totalhr += 1;
                                                                        } else {
                                                                            totalhr += 0.5;
                                                                        }
                                                                    }
                                                                    return (
                                                                        <>
                                                                            {res.length > 0 ?
                                                                                <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }} key={x.employeeID}>{res == undefined ? "-" :
                                                                                    (res[0].totalAmount > 50 && res[0].totalAmount <= 100) ? 1 : 0.5}</TableCell>
                                                                                :
                                                                                <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }} key={x.employeeID}>{"-"}</TableCell>
                                                                            }
                                                                        </>
                                                                    )
                                                                })
                                                            }
                                                            <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>{parseFloat(totalhr)}</TableCell>
                                                        </TableRow >
                                                    )
                                                })}
                                                <TableRow style={{ border: "2px solid black" }}>
                                                    <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }} colSpan={2}>Total</TableCell>
                                                    {dateArray.map(x => {
                                                        const res = total.find(y => parseInt(y.readTime) === parseInt(x))
                                                        return (
                                                            <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }}>{res == undefined ? "-" : parseFloat(res.total).toFixed(1)}</TableCell>
                                                        )
                                                    })}
                                                    <TableCell align="center" style={{ border: "2px solid black", fontWeight: "bold" }} >{parseFloat(hrTotal).toFixed(1)}</TableCell>
                                                </TableRow >
                                            </TableBody>
                                        }
                                    </Table>
                                </TableContainer>
                            </Paper>
                        </Card>
                    </Container>
                    : null}
            </div>
        );
    }
}